import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { SearchContext } from '@zoopla/listing-search-context';
import { SortOrder } from '@zoopla/listing-search/sort-order';
import { useGetMapViewUrl } from '@zoopla/listing-search/use-map-view-url';
import * as React from 'react';
import { FC, useContext } from 'react';
import {
    searchResultsHeaderWrapperStyle,
    searchResultsHeadingStyle,
    searchResultsTotalTextStyle,
    styledDividerStyle,
    styledFooterCellStyle,
    styledFooterStyle
} from './index.styles.css';
import { MapIcon } from './MapIcon';

export type SearchResultsHeaderProps = {
    pageTitle?: string;
};

export const SearchResultsHeader: FC<
    React.PropsWithChildren<SearchResultsHeaderProps>
> = ({ pageTitle }) => {
    const { state } = useContext(SearchContext);

    const totalResultsText = state.totalResultsWasLimited
        ? `${state.totalResults}+ results`
        : `${state.totalResults} results`;

    const mapIconLinkGenericParams = useGetMapViewUrl();

    return (
        <div
            className={searchResultsHeaderWrapperStyle}
            data-testid="search-results-header-control"
        >
            {pageTitle ? (
                <h1
                    className={`${searchResultsHeadingStyle} ${fontGroups.plate}`}
                    data-testid={`results-title`}
                >
                    {pageTitle}
                </h1>
            ) : null}

            <div className={styledFooterStyle}>
                <div className={styledFooterCellStyle}>
                    <p
                        className={`${searchResultsTotalTextStyle} ${fontGroups.ladle}`}
                        data-testid="total-results"
                    >
                        {totalResultsText}
                    </p>
                    <div className={styledDividerStyle} />
                    <MapIcon href={mapIconLinkGenericParams} />
                </div>
                <div className={styledFooterCellStyle}>
                    <SortOrder />
                </div>
            </div>
        </div>
    );
};
